/**
 * Created by mac on 2018/11/26.
 * 网易云-易盾
 * 调起 captchaIns.popUp();
 * <script src="https://cdn-fx.nio.com/fx/apollo-web/__cdn__/js/yidun-captcha.js"></script>
 * https://support.dun.163.com/documents/15588062143475712?docId=294963751458885632
 */
import config from '@/config/index';

const initCaptcha = (option = {}) => {
    return new Promise((resolve, reject) => {
        initNECaptcha(
            {
                // config对象，参数配置
                captchaId: config.netease.captchaId,
                element: '#' + option.element,
                mode: 'popup',
                onVerify: (err, data) => {
                    console.log('onVerify,', data);
                    data && option.callback(data);
                },
                onload: instance => {
                    console.log('onload,', instance);
                },
                onClose: () => {
                    console.log('onClose,', option);
                    option && option.onClose && option.onClose();
                }
            },
            instance => {
                // 初始化成功后得到验证实例instance，可以调用实例的方法
                // console.log('instance', instance);
                resolve(instance);
            },
            err => {
                console.log('err', err);
                reject(err);
            }
        );
    });
};

export default initCaptcha;



// WEBPACK FOOTER //
// ./src/util/third-party/netease-captcha.js